import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default function ConfirmationDialogPopup({confirmPopupObject}) {
  return (
    <Modal
      show={confirmPopupObject.show}
      onHide={() => confirmPopupObject.setShow()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div style={{backgroundColor: "#212529", color: "#ffffff"}}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {confirmPopupObject.title}
        </Modal.Title>
      </Modal.Header>
      {confirmPopupObject?.warning && <Modal.Body>
         <h4 style={{color:'#d17e0f'}}>Warning</h4>
        <p>
          {confirmPopupObject.warning} 
        </p>
      </Modal.Body>}
      <Modal.Footer>
        <Button onClick={() => confirmPopupObject.setShow()}>Cancel</Button>
        <Button variant="danger" onClick={()=> {
            // console.log(confirmPopupObject.action())
            confirmPopupObject.action()}}>{confirmPopupObject.confirmationTitle}</Button>
      </Modal.Footer>
      </div>
    </Modal>
  );
}
